'use client'

import { ComponentProps, useEffect, useRef, useState } from 'react'

import clsx from 'clsx'
import { useWindowSize } from 'react-use'

import { Tooltip, Txt } from 'src/components/atoms'

type TxtProps = ComponentProps<typeof Txt>
type Props = Omit<TxtProps, 'children'> & {
  text: string
  lineLimit: 1 | 2 | 3 | 4 | 5 | 6
}

/** propsのlineLimitで指定した数値で行数制限をかける。文字が見切れる場合はTooltipで全文表示する */
export const LineLimitTxtWithTooltip = ({ text, lineLimit, className, ...otherProps }: Props) => {
  const textReference = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const { width } = useWindowSize()

  useEffect(() => {
    if (textReference.current) {
      const element = textReference.current

      const range = document.createRange()
      range.selectNodeContents(element)

      // テキスト全体の高さを取得
      const rangeHeight = range.getBoundingClientRect().height
      // 要素の表示領域の高さを取得
      const elementHeight = element.getBoundingClientRect().height

      // 省略されているかを判定
      const isContentTruncated = rangeHeight > elementHeight
      setIsTruncated(isContentTruncated)
    }

    // 文字やウィンドウ幅が変わったら再計算
  }, [text, width])

  return (
    <Tooltip showIcon={false} disabled={!isTruncated} content={text}>
      <Txt
        {...otherProps}
        className={clsx(
          lineLimit === 1
            ? 'tw-line-clamp-1'
            : lineLimit === 2
            ? 'tw-line-clamp-2'
            : lineLimit === 3
            ? 'tw-line-clamp-3'
            : lineLimit === 4
            ? 'tw-line-clamp-4'
            : lineLimit === 5
            ? 'tw-line-clamp-5'
            : 'tw-line-clamp-6',
          className
        )}
        ref={textReference}
      >
        {text}
      </Txt>
    </Tooltip>
  )
}
